import { IApplicationData } from 'src/interfaces/ApplicationData';
import { IMarker } from 'src/interfaces/Marker';
import { IMarkerService } from 'src/interfaces/MarkerService';
import { del, post, put } from 'src/utils/apiUtils';
import { MARKER_URL } from './constants';

class MarkerServiceV2 implements IMarkerService {
  private applicationData: IApplicationData;

  constructor(applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  public insertMarker(marker: IMarker) {
    return post(
      MARKER_URL,
      {
        text: marker.text,
        time: marker.time,
      },
      {
        headers: this.requestHeaders,
      },
    );
  }

  public updateMarker(marker: IMarker) {
    const { id } = marker;
    const { reference } = this.applicationData;

    let requestURL = `${MARKER_URL}/${id}`;
    if (reference) requestURL += `?reference=${reference}`;

    return put(
      requestURL,
      { text: marker.text },
      {
        headers: this.requestHeaders,
      },
    );
  }

  public deleteMarker(id: IMarker['id']) {
    const { reference } = this.applicationData;

    let requestURL = `${MARKER_URL}/${id}`;
    if (reference) requestURL += `?reference=${reference}`;

    return del(requestURL, {
      headers: this.requestHeaders,
    });
  }

  private get requestHeaders() {
    const { signature } = this.applicationData;

    return {
      'Content-Type': 'application/json',
      Authorization: signature,
    };
  }
}

export default MarkerServiceV2;
